import React from "react";
import { toast } from "sonner";
import { MapPin, Phone, Mail } from "lucide-react";
import api from "../lib/api";
import { useSettings } from "../contexts/SettingsContext";

export default function Contact() {
    const { settings } = useSettings();
    const [form, setForm] = React.useState({ name: "", email: "", phone: "", subject: "", message: "" });
    const wa = (settings.whatsapp_number || "").replace(/\D/g, "");

    const submit = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post("/contact", form);
            toast.success("Mesaj trimis cu succes!");
            // Also open WhatsApp
            if (res.data.whatsapp_link) {
                window.open(res.data.whatsapp_link, "_blank");
            }
            setForm({ name: "", email: "", phone: "", subject: "", message: "" });
        } catch {
            toast.error("Eroare la trimitere");
        }
    };

    return (
        <div className="container-x py-10" data-testid="contact-page">
            <div className="mb-10">
                <h1 className="font-heading text-5xl uppercase tracking-tighter font-bold">Hai să vorbim</h1>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                <div>
                    <div className="space-y-4 mb-8">
                        {settings.contact_address && <div className="flex gap-3 items-start"><MapPin className="h-5 w-5 text-primary flex-shrink-0 mt-1" /><div><div className="font-mono text-xs uppercase text-muted-foreground">Adresă</div><div>{settings.contact_address}</div></div></div>}
                        {settings.contact_phone && <div className="flex gap-3 items-start"><Phone className="h-5 w-5 text-primary flex-shrink-0 mt-1" /><div><div className="font-mono text-xs uppercase text-muted-foreground">Telefon</div><a href={`tel:${settings.contact_phone}`} className="hover:text-primary">{settings.contact_phone}</a></div></div>}
                        {settings.contact_email && <div className="flex gap-3 items-start"><Mail className="h-5 w-5 text-primary flex-shrink-0 mt-1" /><div><div className="font-mono text-xs uppercase text-muted-foreground">Email</div><a href={`mailto:${settings.contact_email}`} className="hover:text-primary">{settings.contact_email}</a></div></div>}
                    </div>
                    <div className="border-2 border-foreground p-6 bg-muted">
                        <div className="font-heading text-xl uppercase mb-2">Date firmă</div>
                        <div className="font-mono text-xs space-y-1 text-muted-foreground">
                            <div>CUI: {settings.company_cui}</div>
                            <div>Reg. Com.: {settings.company_reg_no}</div>
                            <div>Adresă: {settings.company_address}</div>
                        </div>
                    </div>
                </div>
                <form onSubmit={submit} className="space-y-4">
                    <input required placeholder="Nume" value={form.name} onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="contact-name" />
                    <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="contact-email" />
                    <input placeholder="Telefon" value={form.phone} onChange={(e) => setForm(f => ({ ...f, phone: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="contact-phone" />
                    <input placeholder="Subiect" value={form.subject} onChange={(e) => setForm(f => ({ ...f, subject: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" />
                    <textarea required placeholder="Mesaj" rows="5" value={form.message} onChange={(e) => setForm(f => ({ ...f, message: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="contact-message" />
                    <button type="submit" className="btn-primary w-full" data-testid="contact-submit">Trimite mesajul</button>
                    {settings.contact_phone && (
                        <p className="text-center text-sm text-muted-foreground">Sau ne poți contacta telefonic la <a href={`tel:${settings.contact_phone}`} className="text-primary font-mono">{settings.contact_phone}</a></p>
                    )}
                </form>
            </div>
        </div>
    );
}
